import authAxios from '@services/authAxios';

const fetchSelloutMonitoring = async ({ queries }) => {
    const { data } = await authAxios({
        method: 'GET',
        url: `/api/v1/sellout/data?${queries}`,
    });
    return {
        is_resync: data?.data?.is_resync,
        data: data?.data?.page_data,
        totalData: data?.data?.total_data,
        totalPage: data?.data?.total_page,
    };
};

export default fetchSelloutMonitoring;
